import { createFileRoute } from "@tanstack/react-router";
import { ArrowLeftIcon } from "lucide-react";
import { AiDisclaimer } from "@/components/ai-documents/ai-disclaimer";
import { LongformProgress } from "@/components/ai-documents/longform/longform-progress";
import { Link } from "@/core/lib/navigation";

export const Route = createFileRoute("/_workspace/generate/longform/$buildId")({
  component: LongformBuildPage,
});

function LongformBuildPage() {
  const { buildId } = Route.useParams();
  return (
    <main className="flex flex-1 flex-col p-4 md:p-6">
      <div className="mx-auto w-full max-w-4xl space-y-6">
        <Link
          href="/generate"
          className="inline-flex items-center gap-1.5 text-muted-foreground text-sm underline-offset-4 hover:underline"
        >
          <ArrowLeftIcon className="size-4" />
          Back to Generate
        </Link>
        <div className="space-y-1">
          <h1 className="font-bold text-2xl tracking-tight">Building document</h1>
          <p className="text-muted-foreground text-sm">
            Your content is generated in the background and assembled into one polished document.
          </p>
        </div>
        <LongformProgress buildId={buildId} />
        <AiDisclaimer />
      </div>
    </main>
  );
}
